// src/pages/PersonalProfile.js
import React, { useState, useEffect } from "react";
import LeftNav from "../components/common/LeftNav";
import TopNav from "../components/common/TopNav";
import { useNavigate, useSearchParams } from "react-router-dom";
import crmService from "../../services/crmService";
import "../../assets/styles/PersonalIDs.css";
import "../assets/styles/Ratings.css";
import "../assets/styles/CRMOpenLead.css";

import pencil from "../assets/img/pencil.svg";
import personalleft from "../assets/img/personal-left.svg";
import leadleft from "../assets/img/lead-left.svg";

import filter1 from '../assets/img/filter1.png'
import { FaStar, FaMapMarkerAlt, FaPen ,FaChevronRight,} from "react-icons/fa";
import { FaTimes } from "react-icons/fa"; // import this at the top

// import userImg from "../assets/img/user.svg";
// import star from "../assets/img/star.svg";

export default function PersonalProfile() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get user data from URL parameters
  const userId = searchParams.get('userId');
  const userEmail = searchParams.get('userEmail');
  const userRole = searchParams.get('userRole');
  const userName = searchParams.get('userName');

  // State management matching mobile app
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [profile, setProfile] = useState({});
  const [editedFields, setEditedFields] = useState({});
  const [hasChanges, setHasChanges] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  // Centered alert system
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const showCenteredAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  // Field groups matching mobile app structure
  const FIELD_GROUPS = [
    {
      title: 'Basic Information',
      fields: [
        { key: 'full_name', label: 'Full Name' },
        { key: 'first_name', label: 'First Name' },
        { key: 'last_name', label: 'Last Name' },
        { key: 'email', label: 'Email' },
        { key: 'phone', label: 'Phone' },
        { key: 'company_name', label: 'Company Name' },
      ],
    },
    {
      title: 'Location',
      fields: [
        { key: 'city', label: 'City' },
        { key: 'state', label: 'State' },
        { key: 'address', label: 'Address' },
        { key: 'pincode', label: 'Pincode' },
      ],
    },
    {
      title: 'Professional IDs',
      fields: [
        { key: 'rera_id', label: 'RERA ID' },
        { key: 'pan_number', label: 'PAN Number' },
        { key: 'aadhaar_number', label: 'Aadhaar Number' },
        { key: 'gst_number', label: 'GST Number' },
        { key: 'tan_number', label: 'TAN Number' },
      ],
    },
  ];

  useEffect(() => {
    if (userId) {
      fetchProfile();
    } else {
      // Fallback to URL parameters if no userId
      initializeFromUrlParams();
    }
  }, [userId]);

  const fetchProfile = async () => {
    setLoading(true);
    try {
      const res = await crmService.getFullProfile(userId);
      if (res.success && res.data) {
        setProfile(res.data);
        // Initialize edited fields from profile
        const initial = {};
        FIELD_GROUPS.forEach(group => {
          group.fields.forEach(field => {
            initial[field.key] = res.data[field.key] || '';
          });
        });
        setEditedFields(initial);
      }
    } catch (err) {
      console.error('Failed to load profile:', err);
      // Fallback to URL parameters
      initializeFromUrlParams();
    } finally {
      setLoading(false);
    }
  };

  const initializeFromUrlParams = () => {
    const userPhone = searchParams.get('userPhone');
    const userCity = searchParams.get('userCity');
    const userState = searchParams.get('userState');
    const userRera = searchParams.get('userRera');

    const initial = {};
    if (userName && userEmail) {
      if (userRole === 'agent') {
        const nameParts = userName.split(' ');
        initial.first_name = nameParts[0] || '';
        initial.last_name = nameParts.slice(1).join(' ') || '';
        initial.full_name = userName;
      } else {
        initial.company_name = userName;
        initial.full_name = userName;
      }
      initial.email = userEmail;
      initial.phone = userPhone || '';
      initial.city = userCity || '';
      initial.state = userState || '';
      initial.rera_id = userRera || '';
    }
    setEditedFields(initial);
  };

  const handleFieldChange = (key, value) => {
    setEditedFields(prev => ({ ...prev, [key]: value }));
    setHasChanges(true);
  };

  const handleSave = async () => {
    if (saving || !userId) return;
    setSaving(true);
    try {
      // Only send changed fields (matching mobile app)
      const changedFields = {};
      FIELD_GROUPS.forEach(group => {
        group.fields.forEach(field => {
          const original = profile[field.key] || '';
          const edited = editedFields[field.key] || '';
          if (original !== edited) {
            changedFields[field.key] = edited;
          }
        });
      });

      if (Object.keys(changedFields).length === 0) {
        showCenteredAlert('No fields were modified');
        setSaving(false);
        return;
      }

      const res = await crmService.updateProfile(userId, changedFields);
      if (res.success) {
        showCenteredAlert('Profile updated successfully');
        setHasChanges(false);
        if (res.data) setProfile(res.data);
      } else {
        showCenteredAlert(res.message || 'Failed to update');
      }
    } catch (err) {
      showCenteredAlert('Failed to update profile');
    } finally {
      setSaving(false);
    }
  };


  const toggleSection = (section) => {
    setActiveSection(activeSection === section ? "" : section);
  };
   const [show, setShow] = useState(false);
    const [openIndex, setOpenIndex] = useState(0);
   
    const [activeTab, setActiveTab] = useState("Leads");
     const [selected, setSelected] = useState("5 Star");
   const ratings = ["5 Star", "4 Star", "3 Star", "2 Star", "1 Star"];
  
    const toggleInvoice = (i) => {
      setOpenIndex(openIndex === i ? null : i);
    };

  return (
    <div className="d-flex" style={{ background: "#fff", minHeight: "100vh" }}>
      <LeftNav />
      <div className="main-content flex-grow-1">
        <TopNav />

        {/* Accordion Container */}
        <div className=" p-3">

        

          {/* SECTION 2: Personal Information */}
          <div className="accordion-item mb-3">
            <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("personalinformation")}
            >
              <h6 className="accordion-title mb-0">Personal Information</h6>
              <span className={`accordion-arrow ${activeSection === "personalinformation" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "personalinformation" && (
              <div className="accordion-body">
                <div className="card p-4 personal-ids-card">
              {/* Header */}
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h6 className="personal-head mb-0">
                 
                  Personal Information
                </h6>
 
                {!isEditing ? (
                  <button
                    className="border-0"
                    style={{ background: "none" }}
                    onClick={() => setIsEditing(true)}
                  >
                    <img src={pencil} width={20} height={20} alt="edit" />
                  </button>
                ) : (
                  <></>
                )}
              </div>
 
              {/* Form */}
              <div className="form-group mb-3">
                <label className="form-label personal-label">First Name</label>
                <input
                  type="text"
                  name="firstName"
                  className="form-control personal-input"
                  value={editedFields.first_name || ''}
                  onChange={(e) => handleFieldChange('first_name', e.target.value)}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Last Name</label>
                <input
                  type="text"
                  name="lastName"
                  className="form-control personal-input"
                  value={editedFields.last_name || ''}
                  onChange={(e) => handleFieldChange('last_name', e.target.value)}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Email ID</label>
                <input
                  type="email"
                  name="email"
                  className="form-control personal-input"
                  value={editedFields.email || ''}
                  onChange={(e) => handleFieldChange('email', e.target.value)}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Phone Number</label>
                <input
                  type="text"
                  name="phone"
                  className="form-control personal-input"
                  value={editedFields.phone || ''}
                  onChange={(e) => handleFieldChange('phone', e.target.value)}
                  readOnly={!isEditing}
                />
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">Address</label>
                <textarea
                  name="address"
                  className="form-control personal-input"
                  rows="2"
                  value={editedFields.address || ''}
                  onChange={(e) => handleFieldChange('address', e.target.value)}
                  readOnly={!isEditing}
                ></textarea>
              </div>
 
              <div className="row">
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">Pincode</label>
                  <input
                    type="text"
                    name="pincode"
                    className="form-control personal-input"
                    value={editedFields.pincode || ''}
                    onChange={(e) => handleFieldChange('pincode', e.target.value)}
                    readOnly={!isEditing}
                  />
                </div>
 
                <div className="col-md-6 form-group mb-3">
                  <label className="form-label personal-label">City</label>
                  <input
                    type="text"
                    name="city"
                    className="form-control personal-input"
                    value={editedFields.city || ''}
                    onChange={(e) => handleFieldChange('city', e.target.value)}
                    readOnly={!isEditing}
                  />
                </div>
              </div>
 
              <div className="form-group mb-3">
                <label className="form-label personal-label">State</label>
                <input
                  type="text"
                  name="state"
                  className="form-control personal-input"
                  value={editedFields.state || ''}
                  onChange={(e) => handleFieldChange('state', e.target.value)}
                  readOnly={!isEditing}
                />
              </div>
 
              {/* Save Button in edit mode */}
              {isEditing && (
                <div className="d-flex justify-content-end">
                  <button
                    className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                    onClick={() => {
                      handleSave();
                      setIsEditing(false);
                    }}
                    disabled={saving}
                    style={{ minWidth: "120px" }}
                  >
                    <span className="personal-uspbtntext">{saving ? 'Saving...' : 'Save'}</span>
                  </button>
                </div>
              )}
            </div>
              </div>
            )}
          </div>

            {/* SECTION 1: Personal IDs */}
          <div className="accordion-item mb-3">
           <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("personalids")}
            >
              <h6 className="accordion-title mb-0">Personal IDs</h6>
              <span className={`accordion-arrow ${activeSection === "personalids" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "personalids" && (
              <div className="accordion-body ">
                <div className="card p-4 personal-ids-card">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h6 className="personal-head mb-0">
                     
                      Personal IDs
                    </h6>
                    {!isEditing && (
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => setIsEditing(true)}
                      >
                        <img src={pencil} width={20} height={20} alt="edit" />
                      </button>
                    )}
                  </div>

                  {/* Form */}
                  <div className="form-group mb-3">
                    <label className="form-label personal-label mb-2">
                      REFRA IDs
                    </label>
                    <input
                      type="text"
                      name="refraId"
                      className="form-control personal-input"
                      value={editedFields.rera_id || ''}
                      onChange={(e) => handleFieldChange('rera_id', e.target.value)}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">Aadhaar</label>
                    <input
                      type="text"
                      name="aadhaar"
                      className="form-control personal-input"
                      value={editedFields.aadhaar_number || ''}
                      onChange={(e) => handleFieldChange('aadhaar_number', e.target.value)}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">PAN</label>
                    <input
                      type="text"
                      name="pan"
                      className="form-control personal-input"
                      value={editedFields.pan_number || ''}
                      onChange={(e) => handleFieldChange('pan_number', e.target.value)}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">GST</label>
                    <input
                      type="text"
                      name="gst"
                      className="form-control personal-input"
                      value={editedFields.gst_number || ''}
                      onChange={(e) => handleFieldChange('gst_number', e.target.value)}
                      readOnly={!isEditing}
                    />
                  </div>

                  <div className="form-group mb-3">
                    <label className="form-label personal-label">TAN</label>
                    <input
                      type="text"
                      name="tan"
                      className="form-control personal-input"
                      value={editedFields.tan_number || ''}
                      onChange={(e) => handleFieldChange('tan_number', e.target.value)}
                      readOnly={!isEditing}
                    />
                  </div>

                  {isEditing && (
                    <div className="d-flex justify-content-end">
                      <button
                        className="personal-uspbtn d-flex justify-content-center align-items-center px-4"
                        onClick={() => {
                          handleSave();
                          setIsEditing(false);
                        }}
                        disabled={saving}
                        style={{ minWidth: "120px" }}
                      >
                        <span className="personal-uspbtntext">{saving ? 'Saving...' : 'Save'}</span>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>

          {/* SECTION 3: Ratings & Reviews */}
          <div className="accordion-item mb-3">
            <div
              className="accordion-header d-flex justify-content-between align-items-center"
              onClick={() => toggleSection("ratingsreviews")}
            >
              <h6 className="accordion-title mb-0">Ratings & Reviews</h6>
              <span className={`accordion-arrow ${activeSection === "ratingsreviews" ? "open" : ""}`}>
                ▼
              </span>
            </div>

            {activeSection === "ratingsreviews" && (
              <div className="accordion-body">
               <div>
          <div className="crm-openlead-container p-4">

            {/* Lead ID + actions */}
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h5 style={{fontSize:"18px",fontWeight:"500px"}}> Ratings&Reviews</h5>
              
            </div>
           
        {/* Header */}
        
    
<div  >
    
      {/* About Me */}
      

      {/* Membership */}
     
       <div
    
    >
      
      {/* Toggle Buttons */}
     <div className="d-flex justify-content-between align-items-center mb-4">
                  {/* Tabs */}
                  <div className=" d-flex align-items-center">
                   Total Reviews 1,302
                  </div>
    
                  {/* Action Buttons */}
                  <div className="d-flex gap-2">
                     <button
                  className="btn btn-outline-secondary d-flex align-items-center gap-2 px-3 rounded-3"
                  onClick={() => setShow(true)}
                >
                 
                  Ratings
                   <img src={filter1} alt="filter" width="18" />
                </button>
                     
              {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "12px",
              width: "320px",
              maxWidth: "95%",
              boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
              position: "relative",
              padding: "20px",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "15px",
                fontWeight: "600",
                fontSize: "16px",
              }}
            >
              Filter by Ratings
             <button
  onClick={() => setShow(false)}
  style={{
    background: "transparent",
    border: "1px solid #ccc",     // 👈 light gray border
    fontSize: "18px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "32px",                // square button
    height: "32px",
    borderRadius: "6px",          // round shape
  }}
>
  <FaTimes size={15} color="#555" />
</button>

            </div>

            {/* Ratings List */}
            <div>
              {ratings.map((rating, index) => (
                <div
                  key={index}
                  onClick={() => setSelected(rating)}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "10px 12px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    marginBottom: "8px",
                    background:
                      selected === rating ? "rgba(111,112,250,0.15)" : "transparent",
                    color: "#000",
                  }}
                >
                  <span>{rating}</span>
                  <input
                    type="checkbox"
                    checked={selected === rating}
                    readOnly
                    style={{
                      width: "18px",
                      height: "18px",
                      accentColor: "#6f70fa",
                      cursor: "pointer",
                    }}
                  />
                </div>
              ))}
            </div>

            {/* Footer Buttons */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "20px",
              }}
            >
              <button
                onClick={() => setSelected("")}
                style={{
                  border: "1px solid #6f70fa",
                  color: "#6f70fa",
                  background: "transparent",
                  fontWeight: "600",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Clear Filters
              </button>
              <button
                onClick={() => setShow(false)}
                style={{
                  background: "linear-gradient(90deg, #6f70fa 0%, #7367f0 100%)",
                  border: "none",
                  color: "#fff",
                  fontWeight: "600",
                  padding: "8px 20px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}        
                   
    
                    
                      
                      
                    
    
                  </div>
                </div>

      {/* Invoice List */}
      <div
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",

       padding:"10px",
        fontFamily: "Arial, sans-serif",
          marginBottom:"10px"
      }}
    >
      {/* Header: Avatar + Name + Rating */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="https://randomuser.me/api/portraits/women/45.jpg" // replace with real avatar
            alt="Neha Sharma"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              marginRight: "10px",
              objectFit: "cover",
            }}
          />
          <span style={{ fontWeight: "600", fontSize: "14px" }}>Neha Sharma</span>
        </div>

        {/* Rating Badge */}
        <div
          style={{
            background: "#FFD84D",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "600",
            padding: "4px 10px",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          5 <FaStar size={12} color="#fff" />
        </div>
      </div>

      {/* Review Text */}
      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        Rajesh and his team were incredibly helpful throughout our property
        search. They understood our requirements perfectly and showed us
        properties that matched our needs. The transaction was smooth and
        hassle-free.
      </p>

      {/* Date */}
      <div style={{ fontSize: "13px", color: "#777" }}>May 12, 2025</div>
    </div>
    <div
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",

       padding:"10px",
        fontFamily: "Arial, sans-serif",
          marginBottom:"10px"
      }}
    >
      {/* Header: Avatar + Name + Rating */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="https://randomuser.me/api/portraits/women/45.jpg" // replace with real avatar
            alt="Neha Sharma"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              marginRight: "10px",
              objectFit: "cover",
            }}
          />
          <span style={{ fontWeight: "600", fontSize: "14px" }}>Neha Sharma</span>
        </div>

        {/* Rating Badge */}
        <div
          style={{
            background: "#FFD84D",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "600",
            padding: "4px 10px",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          5 <FaStar size={12} color="#fff" />
        </div>
      </div>

      {/* Review Text */}
      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        Rajesh and his team were incredibly helpful throughout our property
        search. They understood our requirements perfectly and showed us
        properties that matched our needs. The transaction was smooth and
        hassle-free.
      </p>

      {/* Date */}
      <div style={{ fontSize: "13px", color: "#777" }}>May 12, 2025</div>
    </div>

    <div
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",

       padding:"10px",
        fontFamily: "Arial, sans-serif",
        marginBottom:"10px"
      }}
    >
      {/* Header: Avatar + Name + Rating */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="https://randomuser.me/api/portraits/women/45.jpg" // replace with real avatar
            alt="Neha Sharma"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              marginRight: "10px",
              objectFit: "cover",
            }}
          />
          <span style={{ fontWeight: "600", fontSize: "14px" }}>Neha Sharma</span>
        </div>

        {/* Rating Badge */}
        <div
          style={{
            background: "#FFD84D",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "600",
            padding: "4px 10px",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          5 <FaStar size={12} color="#fff" />
        </div>
      </div>

      {/* Review Text */}
      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        Rajesh and his team were incredibly helpful throughout our property
        search. They understood our requirements perfectly and showed us
        properties that matched our needs. The transaction was smooth and
        hassle-free.
      </p>

      {/* Date */}
      <div style={{ fontSize: "13px", color: "#777" }}>May 12, 2025</div>
    </div>
      <div
      style={{
        border: "1px solid #eee",
        borderRadius: "10px",

       padding:"10px",
        fontFamily: "Arial, sans-serif",
          marginBottom:"10px"
      }}
    >
      {/* Header: Avatar + Name + Rating */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "10px",
        }}
      >
        {/* Avatar + Name */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src="https://randomuser.me/api/portraits/women/45.jpg" // replace with real avatar
            alt="Neha Sharma"
            style={{
              width: "35px",
              height: "35px",
              borderRadius: "50%",
              marginRight: "10px",
              objectFit: "cover",
            }}
          />
          <span style={{ fontWeight: "600", fontSize: "14px" }}>Neha Sharma</span>
        </div>

        {/* Rating Badge */}
        <div
          style={{
            background: "#FFD84D",
            color: "#fff",
            fontSize: "13px",
            fontWeight: "600",
            padding: "4px 10px",
            borderRadius: "6px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          5 <FaStar size={12} color="#fff" />
        </div>
      </div>

      {/* Review Text */}
      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.6",
          color: "#333",
          marginBottom: "10px",
        }}
      >
        Rajesh and his team were incredibly helpful throughout our property
        search. They understood our requirements perfectly and showed us
        properties that matched our needs. The transaction was smooth and
        hassle-free.
      </p>

      {/* Date */}
      <div style={{ fontSize: "13px", color: "#777" }}>May 12, 2025</div>
    </div>
    <button
  style={{
    background: "transparent",
    border: "1px solid #007bff", // blue border
    color: "#007bff",            // blue text
    fontWeight: "600",
    padding: "8px 16px",
    borderRadius: "8px",
    cursor: "pointer",
    width:"100%"
  }}
>
  View All Reveiews
</button>

    </div>
   
    

      



     

     

      
</div>





            

          
          </div>
        </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Centered Alert Modal */}
      {showAlert && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '20px 30px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
            textAlign: 'center',
            minWidth: '300px'
          }}>
            <p style={{ margin: '0 0 15px 0', fontSize: '16px', color: '#333' }}>
              {alertMessage}
            </p>
            <button
              onClick={() => setShowAlert(false)}
              style={{
                backgroundColor: '#6366F1',
                color: 'white',
                border: 'none',
                padding: '8px 20px',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
